import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig, apiRequest, loginRequest } from "./authConfig";
import { getRuntimeConfig } from "../runtime-config";

export const msalInstance = new PublicClientApplication(msalConfig);

let cachedAccessToken = null;
const config = getRuntimeConfig();
const VITE_API_APPLICATION_ID_URI = fixScope(config.API_APPLICATION_ID_URI);

function fixScope(scope) {
  return scope.replace(".default", "user_impersonation");
}

export async function getAccessToken() 
{
  if (cachedAccessToken) return cachedAccessToken;
  try {
    const tokenResponse = await msalInstance.acquireTokenSilent({
     scopes: [VITE_API_APPLICATION_ID_URI],

    });
  
    return tokenResponse.accessToken;
  } catch (silentError) {
    console.warn("Silent token acquisition failed, falling back to popup:", silentError);
  }
}
